export default __webpack_public_path__ + "static/007-2d8dd9d71b72bbf112c8eea01110baf0.jpg";